import { VerifyCPF } from 'utils/utils'

export const getCpfStatus = (cpf) => {
    const digits = cpf.replace(/\D/g, '')
    const completo = digits.length === 11
    const invalido = completo && !VerifyCPF(cpf)
    return { completo, invalido }
}
